import styled from 'styled-components';
import SuccessPageAttribution from 'views/PostEnrollment/SuccessPageAttribution';
import SuccessPageButton from 'views/PostEnrollment/SuccessPageButtons';
import cbNoRewardsCard from 'views/SuccessCBRewards/cbNoRewardsCard.svg';
import {
  CenteredStickySubmitButtonWrapper,
  Content,
  SpacedChecklistDisclaimerText,
  Title,
} from 'views/SuccessCBRewards/Layout';
import {
  RewardsOrderedList,
  RewardsOrderedListText,
} from 'views/SuccessCBRewards/RewardsOrderedList';

import { GhostLink } from 'chime-ui/components/Button';

import {
  Card,
  PageWrapper,
  PostEnrollmentChimeLogo as ChimeLogo,
} from 'styles/styleMixins';

import { atmFeesArticleLink } from 'utils/linkHelper';

const seeDetailsLinkText = 'See here for details.';
const seeDetailsLink = atmFeesArticleLink;

const SuccessPage = () => {
  return (
    <SuccessPageAttribution>
      <PageWrapper>
        <Card showFooterDisclosure>
          <Content>
            <ChimeLogo alwaysShow />
            <CBNoRewardsCard />
            <Title>Credit Builder* helps you unlock Cash Rewards</Title>
            <RewardsOrderedList>
              <RewardsOrderedListText>
                Increase your FICO® Score by an average of 30 points
                <sup>1</sup>
              </RewardsOrderedListText>
              <RewardsOrderedListText>
                Unlock the Cash Rewards card with a qualifying credit score
              </RewardsOrderedListText>
              <RewardsOrderedListText>
                No interest or annual fees<sup>2</sup>
              </RewardsOrderedListText>
            </RewardsOrderedList>
            <CenteredStickySubmitButtonWrapper>
              <SuccessPageButton
                justifyContent="center"
                variation="l"
                eventContext="success_cb_no_rewards"
              >
                Get the app
              </SuccessPageButton>
            </CenteredStickySubmitButtonWrapper>
          </Content>
        </Card>
        <SpacedChecklistDisclaimerText>
          * Receive a single $200+ qualifying direct deposit into your Chime
          Checking Account within 30 days of submitting your application.
          <br />
          <br />
          <sup>1</sup> Based on a study conducted by Experian®, Credit Builder
          members observed an average 30 point FICO® Score 8 increase after 8
          months, with regular on-time payments. Results may vary, see Chime.com
          for details.
          <br />
          <br />
          <sup>2</sup> Out-of-network ATM withdrawal fees may apply.{' '}
          <GhostLink href={seeDetailsLink} target="_blank">
            {seeDetailsLinkText}
          </GhostLink>
        </SpacedChecklistDisclaimerText>
      </PageWrapper>
    </SuccessPageAttribution>
  );
};

export default SuccessPage;

const CBNoRewardsCard = styled.img.attrs({
  src: cbNoRewardsCard,
  alt: 'Credit Builder Path To Rewards',
})`
  width: 100%;
  margin-left: -1rem;
`;
